/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Divider as MuiDivider, styled } from "@mui/material";

export const TopContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "8px",
    width: "auto",
  },
}));

export const BottomContainer = styled("div")({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
});

export const PriceWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  [theme.breakpoints.up("sm")]: {
    marginTop: "8px",
    flexDirection: "row",
    gap: "24px",
  },
}));

export const CardTitleWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const StatusWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "8px",
});

export const Divider = styled(MuiDivider)(({ theme }) => ({
  borderColor: theme.colors.primary100,
  margin: "8px 0",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));
